import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import SystemLogs from '../components/SystemLogs';

const LogListPage = () => {
  return (
    <div>
      <NavbarTop />
      <SystemLogs />
      <NavbarBottom />
    </div>
  );
};

export default LogListPage;
